import { CodeLanguages } from '../../../api/private/global.interface';
import { DefaultCodeLanguages } from '../../../api/public/code-api';
import { SL_CODE_SUPPORTED_LANGUAGES } from '../../../code/public/global/constants';

export enum LanguageRoutes {
	WEB = 'web',
	CPP = 'cpp',
	C = 'c',
	PHP = 'php',
	JAVA = 'java',
	PYTHON = 'python',
	SWIFT = 'swift',
	CSharp = 'csharp',
	RUBY = 'ruby',
	NODEJS = 'nodejs',
	KOTLIN = 'kotlin',
	JQUERY = 'jquery',
	JAVASCRIPT = 'js',
	SQL = 'sql',
	GO = 'go',
	R = 'r',
}

export const MappingApiLanguageToMonacoLanguage = {
	[CodeLanguages.CPP]: SL_CODE_SUPPORTED_LANGUAGES.CPP,
	[CodeLanguages.C]: SL_CODE_SUPPORTED_LANGUAGES.C,
	[CodeLanguages.CSharp]: SL_CODE_SUPPORTED_LANGUAGES.CSharp,
	[CodeLanguages.JAVA]: SL_CODE_SUPPORTED_LANGUAGES.JAVA,
	[CodeLanguages.PYTHON]: SL_CODE_SUPPORTED_LANGUAGES.PYTHON,
	[CodeLanguages.PHP]: SL_CODE_SUPPORTED_LANGUAGES.PHP,
	[CodeLanguages.RUBY]: SL_CODE_SUPPORTED_LANGUAGES.RUBY,
	[CodeLanguages.KOTLIN]: SL_CODE_SUPPORTED_LANGUAGES.KOTLIN,
	[CodeLanguages.SWIFT]: SL_CODE_SUPPORTED_LANGUAGES.SWIFT,
	[CodeLanguages.NODEJS]: SL_CODE_SUPPORTED_LANGUAGES.JAVASCRIPT,
	[CodeLanguages.JS]: SL_CODE_SUPPORTED_LANGUAGES.JAVASCRIPT,
	[CodeLanguages.CSS]: SL_CODE_SUPPORTED_LANGUAGES.CSS,
	[CodeLanguages.HTML]: SL_CODE_SUPPORTED_LANGUAGES.HTML,
	[CodeLanguages.SQL]: SL_CODE_SUPPORTED_LANGUAGES.SQL,
};

export const MappingRouteLanguageToDefaultCodeGetting = {
	[LanguageRoutes.JQUERY]: {
		defaultCodeApi: DefaultCodeLanguages.JQUERY,
	},
	[LanguageRoutes.WEB]: {
		defaultCodeApi: DefaultCodeLanguages.WEB,
	},
	[LanguageRoutes.CPP]: {
		defaultCodeApi: DefaultCodeLanguages.CPP,
	},
	[LanguageRoutes.C]: {
		defaultCodeApi: DefaultCodeLanguages.C,
	},
	[LanguageRoutes.PHP]: {
		defaultCodeApi: DefaultCodeLanguages.PHP,
	},
	[LanguageRoutes.JAVA]: {
		defaultCodeApi: DefaultCodeLanguages.JAVA,
	},
	[LanguageRoutes.PYTHON]: {
		defaultCodeApi: DefaultCodeLanguages.PYTHON,
	},
	[LanguageRoutes.SWIFT]: {
		defaultCodeApi: DefaultCodeLanguages.SWIFT,
	},
	[LanguageRoutes.CSharp]: {
		defaultCodeApi: DefaultCodeLanguages.CS,
	},
	[LanguageRoutes.RUBY]: {
		defaultCodeApi: DefaultCodeLanguages.RUBY,
	},
	[LanguageRoutes.KOTLIN]: {
		defaultCodeApi: DefaultCodeLanguages.KOTLIN,
	},
	[LanguageRoutes.NODEJS]: {
		defaultCodeApi: DefaultCodeLanguages.NODEJS,
	},
	[LanguageRoutes.GO]: {
		defaultCodeApi: DefaultCodeLanguages.GO,
	},
	[LanguageRoutes.R]: {
		defaultCodeApi: DefaultCodeLanguages.R,
	},
};
export interface ILanguageType {
	color: string;
	boxShadow: string;
	language: CodeLanguages;
	title: string;
	path: LanguageRoutes;
	show: boolean;
	label?: string;
}

export const LANGUAGE_TYPES: ILanguageType[] = [
	{
		color: '#E54D26',
		boxShadow: 'rgba(229, 77, 38, 0.45)',
		title: 'Web',
		language: CodeLanguages.WEB,
		path: LanguageRoutes.WEB,
		show: true,
	},
	{
		color: '#0C6291',
		boxShadow: 'rgba(12, 98, 145, 0.45)',
		title: 'C++',
		language: CodeLanguages.CPP,
		path: LanguageRoutes.CPP,
		label: 'CPP',
		show: true,
	},
	{
		color: '#6085BC',
		boxShadow: 'rgba(96, 133, 188, 0.45)',
		title: 'PHP',
		language: CodeLanguages.PHP,
		path: LanguageRoutes.PHP,
		label: 'PHP',
		show: true,
	},
	{
		color: '#FA9722',
		boxShadow: 'rgba(250, 151, 34, 0.45)',
		title: 'Java',
		language: CodeLanguages.JAVA,
		path: LanguageRoutes.JAVA,
		label: 'JAVA',
		show: true,
	},
	{
		color: '#8DB93E',
		boxShadow: 'rgba(141, 185, 62, 0.45)',
		title: 'Node js',
		language: CodeLanguages.NODEJS,
		path: LanguageRoutes.NODEJS,
		label: 'NODE',
		show: true,
	},
	{
		color: '#652F91',
		boxShadow: 'rgba(101, 47, 145, 0.45)',
		title: 'C#',
		language: CodeLanguages.CSharp,
		path: LanguageRoutes.CSharp,
		label: 'CS',
		show: true,
	},
	{
		color: '#E04E3F',
		boxShadow: 'rgba(224, 78, 63, 0.45)',
		title: 'Ruby',
		language: CodeLanguages.RUBY,
		path: LanguageRoutes.RUBY,
		label: 'RB',
		show: true,
	},
	{
		color: '#2196F3',
		boxShadow: 'rgba(33, 150, 243, 0.45)',
		title: 'C',
		language: CodeLanguages.C,
		path: LanguageRoutes.C,
		label: 'C',
		show: true,
	},
	{
		color: '#F25F33',
		boxShadow: 'rgba(242, 95, 51, 0.45)',
		title: 'Swift',
		language: CodeLanguages.SWIFT,
		path: LanguageRoutes.SWIFT,
		label: 'SWIFT',
		show: true,
	},
	{
		color: '#3396D7',
		boxShadow: 'rgba(51, 150, 215, 0.45)',
		title: 'Kotlin',
		language: CodeLanguages.KOTLIN,
		path: LanguageRoutes.KOTLIN,
		label: 'KT',
		show: true,
	},
	{
		color: '#134C7A',
		boxShadow: 'rgba(19, 76, 122, 0.45)',
		title: 'Python',
		language: CodeLanguages.PYTHON,
		path: LanguageRoutes.PYTHON,
		label: 'PY',
		show: true,
	},
	{
		color: '#4162AB',
		boxShadow: 'rgba(65, 98, 171, 0.45)',
		title: 'jQuery',
		language: CodeLanguages.JQUERY,
		path: LanguageRoutes.JQUERY,
		show: true,
	},
	{
		color: '#4162AB',
		boxShadow: 'rgba(65, 98, 171, 0.45)',
		title: 'sql',
		language: CodeLanguages.SQL,
		label: 'SQL',
		path: LanguageRoutes.SQL,
		show: false,
	},
	{
		color: '#00ACD7',
		boxShadow: 'rgba(65, 98, 171, 0.45)',
		title: 'Go',
		language: CodeLanguages.GO,
		label: 'GO',
		path: LanguageRoutes.GO,
		show: true,
	},
	{
		color: '#2066B8',
		boxShadow: 'rgba(65, 98, 171, 0.45)',
		title: 'R',
		language: CodeLanguages.R,
		label: 'R',
		path: LanguageRoutes.R,
		show: true,
	},
];
